/* eslint-disable */
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor() { }

  /*================================================================
  # AWAIT
  ================================================================*/
  async await(delay: number = 1000){
    await new Promise((resolve, reject) => setTimeout(() => resolve(true), delay));
  }

  /*================================================================
  # CREATE NAME
  ================================================================*/
  // @ts-ignore
  createName(a="",b=""){a||(a=this.rand(0,100)%2?"m":"f");const c=["a","e","i","o","u"],d=["b","c","d","f","g","h","j","k","l","m","n","p","q","r","s","t","v","w","x","z"];if("v"==b)return c[this.rand(0,c.length-1)];if("c"==b)return d[this.rand(0,d.length-1)];let e=this.rand(4,8),f=0,g=0,h="",j="";for(let c=0;c<e-1;c++){if(0==c&&(0==this.rand(0,1e3)%2?(b=this.createName(a,"v"),h=b,j+=b,g+=1):(b=this.createName(a,"c"),h=b,j+=b,f+=1)),g!=1){do b=this.createName(a,"v");while(b==h);h=b,j+=b,g+=1,f=0}else if(f!=2){do b=this.createName(a,"c");while(b==h);h=b,j+=b,f+=1,g=0}"f"==a&&c==e-2&&"a"!=j.substring(0,j.length-2)&&(j=j.substring(0,j.length-1)+"a")}return this.ucFirst(j)}

  /*================================================================
  # CONVERT TO OBJECT (IF NEEDED)
  ================================================================*/
  apiConv(a: string){
    try {
      return JSON.parse(a);
    } catch (error) {
      return a;
    }
  }
  
  /*================================================================
  # COPY TO CLIPBOARD
  ================================================================*/
  copyToClipboard(val: string){
    const e=document.createElement("textarea");e.style.cssText="position:fixed;left:0;top:0;opacity:0",e.value=val,document.body.appendChild(e),e.focus(),e.select();try{document.execCommand("copy")||console.error("Copy command was unsuccessful")}catch(e){console.error("Unable to copy text")}document.body.removeChild(e);
  }

  /*================================================================
  # CONVERT STR TO OBJ
  ================================================================*/
  // @ts-ignore
  convStrToObj(a){if(Array.isArray(a)){const b=[];a.forEach(a=>{b.push(this.convStrToObj(a))}),a=b}else{const b={};Object.keys(a).forEach(c=>{b[c]=this.isJson(a[c])?JSON.parse(a[c]):a[c]}),a=b}return a}

  // @ts-ignore
  isJson(a){try{JSON.parse(a)}catch(a){return!1}return!0}

  /*================================================================
  # STRING MANIPOLATION
  ================================================================*/
  sanitize(t: string){return t.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"").replace(/-{2,}/g,"-")}

  // @ts-ignore
  ucFirst(str) { return str.charAt(0).toUpperCase() + str.slice(1) }
  
  // @ts-ignore
  nl2br(a,b=true,c=true){var d=c?"<br />":"<br>",e=b?"$1"+d:"$1"+d+"$2";return(a+"").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,e)}
  
  // @ts-ignore
  br2nl(a,b=true){var c=b?"\n":"";return a.replace(/<\s*\/?br\s*[\/]?>/gi,c)}

  /*================================================================
  # URL HASH
  ================================================================*/
  addHashUrl(newHash: string = ''): void {
    const originalUrl = window.location.href;
    let [preUrl, url] = originalUrl.split('/#/');
    
    const hashIndex = url.lastIndexOf('#');
    let newUrl: string;
  
    if (hashIndex !== -1) {
      const baseUrl = url.substring(0, hashIndex);
      const currentHash = url.substring(hashIndex + 1);
  
      if(!newHash){
        newUrl = `${baseUrl}`;
      }else{

      if (currentHash.startsWith('/#/')) {
          newUrl = `${baseUrl}#${newHash}${currentHash.substring(3)}`;   
      } else {
          newUrl = `${baseUrl}#${newHash}`;
      }
    }
    } else {
      if(!newHash){
        newUrl = `${url}`;
      }else{
        newUrl = `${url}#${newHash}`;
      }
    }
  
    window.location.href = (preUrl ? `${preUrl}/#/` : '') + newUrl;
  }

  getHashUrl(): string {
    let url: string = window.location.href.split('/#/')[1] || '';
    const hashIndex = url.lastIndexOf('#');
    return (hashIndex !== -1) ? url.substring(hashIndex + 1) : '';
  }

  /*================================================================
  # ARRAY MANIPOLATION
  ================================================================*/
  // @ts-ignore
  shuffle(a){for(let b,c=a.length;0!=c;)b=Math.floor(Math.random()*c),c--,[a[c],a[b]]=[a[b],a[c]];return a}

  /*================================================================
  # NUMBER MANIPULATIONS
  ================================================================*/
  // @ts-ignore
  format(n:any){ return n<10?n='0'+n:n; }

  // @ts-ignore
  isNumber(value:any) { return typeof value === 'number' && isFinite(value) };

  // @ts-ignore
  formatnum(a,b=2,c=",",d=""){a=(a+"").replace(",",".").replace(/[^0-9+\-Ee.]/g,"");var e=isFinite(+a)?+a:0,f=isFinite(+b)?Math.abs(b):0,g="undefined"==typeof d?",":d,h="undefined"==typeof c?".":c,i="";return i=(f?function(a,b){var c=Math.pow(10,b);return""+Math.round(a*c)/c}(e,f):""+Math.round(e)).split("."),3<i[0].length&&(i[0]=i[0].replace(/\B(?=(?:\d{3})+(?!\d))/g,g)),(i[1]||"").length<f&&(i[1]=i[1]||"",i[1]+=Array(f-i[1].length+1).join("0")),i.join(h)}

  // @ts-ignore
  rand(a,b){return a=Math.ceil(a),b=Math.floor(b),Math.floor(Math.random()*(b-a+1))+a}

  /*================================================================
  # DATE MANIPULATION 
  ================================================================*/
  // @ts-ignore
  date(n,t=""){""==t&&(t=Math.floor(Date.now()/1e3));function e(n,t){return i[n]?i[n]():t}function r(n,t){for(n+="";n.length<t;)n="0"+n;return n}var u=["Sun","Mon","Tues","Wednes","Thurs","Fri","Satur","January","February","March","April","May","June","July","August","September","October","November","December"],o=/\\?(.?)/gi,i={d:function(){return r(i.j(),2)},D:function(){return i.l().slice(0,3)},j:function(){return c.getDate()},l:function(){return u[i.w()]+"day"},N:function(){return i.w()||7},S:function(){var n=i.j(),t=n%10;return t<=3&&1===parseInt(n%100/10,10)&&(t=0),["st","nd","rd"][t-1]||"th"},w:function(){return c.getDay()},z:function(){var n=new Date(i.Y(),i.n()-1,i.j()),t=new Date(i.Y(),0,1);return Math.round((n-t)/864e5)},W:function(){var n=new Date(i.Y(),i.n()-1,i.j()-i.N()+3),t=new Date(n.getFullYear(),0,4);return r(1+Math.round((n-t)/864e5/7),2)},F:function(){return u[6+i.n()]},m:function(){return r(i.n(),2)},M:function(){return i.F().slice(0,3)},n:function(){return c.getMonth()+1},t:function(){return new Date(i.Y(),i.n(),0).getDate()},L:function(){var n=i.Y();return 0==n%4&0!=n%100|0==n%400},o:function(){var n=i.n(),t=i.W();return i.Y()+(12===n&&t<9?1:1===n&&9<t?-1:0)},Y:function(){return c.getFullYear()},y:function(){return i.Y().toString().slice(-2)},a:function(){return 11<c.getHours()?"pm":"am"},A:function(){return i.a().toUpperCase()},B:function(){var n=3600*c.getUTCHours(),t=60*c.getUTCMinutes(),e=c.getUTCSeconds();return r(Math.floor((n+t+e+3600)/86.4)%1e3,3)},g:function(){return i.G()%12||12},G:function(){return c.getHours()},h:function(){return r(i.g(),2)},H:function(){return r(i.G(),2)},i:function(){return r(c.getMinutes(),2)},s:function(){return r(c.getSeconds(),2)},u:function(){return r(1e3*c.getMilliseconds(),6)},e:function(){throw new Error("Not supported (see source code of date() for timezone on how to add support)")},I:function(){return new Date(i.Y(),0)-Date.UTC(i.Y(),0)==new Date(i.Y(),6)-Date.UTC(i.Y(),6)?0:1},O:function(){var n=c.getTimezoneOffset(),t=Math.abs(n);return(0<n?"-":"+")+r(100*Math.floor(t/60)+t%60,4)},P:function(){var n=i.O();return n.substr(0,3)+":"+n.substr(3,2)},T:function(){return"UTC"},Z:function(){return 60*-c.getTimezoneOffset()},c:function(){return"Y-m-d\\TH:i:sP".replace(o,e)},r:function(){return"D, d M Y H:i:s O".replace(o,e)},U:function(){return 0|c/1e3}},n=n,c=void 0===(t=t)?new Date:t instanceof Date?new Date(t):new Date(1e3*t);return n.replace(o,e)}

  // @ts-ignore
  mktime(hour=this.date("H"),minutes=this.date("i"),seconds=this.date("s"),month=this.date("n"),day=this.date("d"),year=this.date("Y")){ return new Date(year, month - 1, day, hour, minutes, seconds, 0).getTime() / 1000;}
  
  // @ts-ignore
  now(a=0){return a?this.date("Y-m-d H:i:s",parseInt(a)):this.date("Y-m-d H:i:s")}

  // @ts-ignore
  timestamp(b:any=0){var a=0;if(!b)a=this.mktime();else if(-1!=b.indexOf(" - ")){var f=b.split(" - "),g=f[0].split("/"),h=f[1].split(":");a=this.mktime(h[0],h[1],0,g[1],g[0],g[2])}else if(-1!=b.indexOf(" "))f=b.split(" "),g=f[0].split("-"),h=f[1].split(":"),a=this.mktime(h[0],h[1],h[2],g[1],g[2],g[0]);else if(-1!=b.indexOf("-")){var h=b.split("-");a=this.mktime(0,0,0,h[1],h[2],h[0])}else f=b.split("/"),a=this.mktime(0,0,0,f[1],f[0],f[2]);return parseInt(a)}

  // @ts-ignore
  standardDate(a=""){if(a){if(-1==a.indexOf(" - ")){var b=a.split("/");return a=this.mktime(0,0,0,b[1],b[0],b[2]),a=date("Y-m-d H:i:s",a),a}var b=a.split(" - "),c=b[0].split("/"),d=b[1].split(":");return a=this.mktime(d[0],d[1],0,c[1],c[0],c[2]),a=this.date("Y-m-d H:i:s",a),a}return this.date("Y-m-d H:i:s")}

  // @ts-ignore
  italyDate(b="",c=0){if(b||(b=this.now()),b&&"-1"!=b.indexOf(":")){var d=b.split(" "),f=d[0].split("-"),g=d[1].split(":");return c?this.date("d/m/Y - H:i",this.mktime(g[0],g[1],g[2],f[1],f[2],f[0])):this.date("d/m/Y",this.mktime(g[0],g[1],g[2],f[1],f[2],f[0]))}return""}

  // @ts-ignore
  date_diff(a,b,c="giorni"){var d=this.timestamp(b),e=this.timestamp(a),f=e-d;return"giorni"==c?(f/=86400,Math.round(f)):(f/=60,c=='giorni'?this.mtoh(f):this.mtos(f))}

  // @ts-ignore
  timeToObj(time){return new Date(time * 1000)}
  timeFromUTC(time: string){return Date.parse(time)/1000}

  // @ts-ignore
  mtoh(t,n=!1){t=new Date(1e3*t).toISOString().slice(11, 19);return n||(t=t.substr(3)),t}

  // @ts-ignore
  mtos(a){a*=60;let b=Math.floor(a/3600);a%=3600;let c=Math.floor(a/60),d=Math.round(a%60);return this.format(b)+":"+this.format(c)+":"+this.format(d)}

  // @ts-ignore
  counterBySeconds(a,b=""){b||(b=this.timestamp()+"");let c=Math.abs(parseInt(a)-parseInt(b)),d=Math.floor(c/86400);c-=86400*d;let e=Math.floor(c/3600)%24;c-=3600*e;let f=Math.floor(c/60)%60;c-=60*f;let g=c%60;return this.format(d)+":"+this.format(e)+":"+this.format(f)+":"+this.format(g)}

  // @ts-ignore
  htom(a){a=a.split(":");var b=60*parseInt(a[0]),c=parseInt(a[1]);return b+c}

  // @ts-ignore
  mesi(a){return["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"][a-1]}
  
  // @ts-ignore
  week(a){return["Domenica","Luned\xEC","Marted\xEC","Mercoled\xEC","Gioved\xEC","Venerd\xEC","Sabato","Domenica"][a]}

  /*================================================================
  # CRYPTO
  ================================================================*/
  // @ts-ignore
  md5(text){text=text.toString(); return CryptoJS.MD5(text).toString()}
  
  // @ts-ignore
  createCode(a=15){for(var b="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890!$%&/()=?@-_:.;,*[]{}#",c="",d=0;d<a;d++)c+=b[this.rand(0,b.length-1)];return c}

  // @ts-ignore
  cripto(d,e=0,b='ZW52aXJvbm1lbnQuc2VjdXJlLnB3ZA'){return 0===e?(d=CryptoJS.AES.encrypt(d,b).toString(),d=d.replace(/\//g,"3uXu3"),d=d.replace(/\\/g,"2aXa2"),d=d.replace(/\+/g,"-"),d=d.replace(/=/g,"_")):null!==d&&(d=d.replace(/3uXu3/g,"/"),d=d.replace(/2aXa2/g,"\\"),d=d.replace(/-/g,"+"),d=d.replace(/_/g,"="),d=CryptoJS.AES.decrypt(d,b).toString(CryptoJS.enc.Utf8)),d}

  // @ts-ignore
  pwd(text){ return CryptoJS.SHA256('xq'+text+'qx').toString(); }

  /*================================================================
  # EXTRA
  ================================================================*/
  rndColor(a=""){if(!a)return"#"+Math.floor(16777215*Math.random()).toString(16);for(var b,c=1,d=Math.random(),e="#";c<a.length;)b=parseInt(a.slice(c,c+=2),16),b+=Math.floor((255-b)*d),e+=b.toString(16).padStart(2,"0");return e}

  /*================================================================
  # FORM FUNCTIONS
  ================================================================*/
  validEmail(email: string){
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  fillFields(form: any, obj: any) {
		if (obj?.key && (obj.value || obj.value === null)) {
			const input = form.controls[obj.key] ? form.controls[obj.key] : null;
			if (input) {
				input.setValue(obj.value);
			}
		} else {
      if(obj !== undefined){
        Object.keys(form.controls).forEach(key => {
          const value = obj[key] ? obj[key] : '';
          if (key && value) {
            this.fillFields(form, { key, value });
          }   
        });
      }
		}
	}

  getFormValidationErrors(form: any) {
    const controls = form?.controls;
    let errors: any = [];
    Object.keys(controls).forEach(key => {
      const controlErrors = controls[ key ].errors;
      if (controlErrors !== null) {
        Object.keys(controlErrors).forEach(keyError => {
          errors.push({
            control_name: key,
            error_name: keyError,
            error_value: controlErrors[ keyError ]
          });
        });
      }
    });
    return errors;
  }

  formValidation(form: any){
    const error = this.getFormValidationErrors(form).shift();
    let text = '';
    if (error) {
      switch (error.error_name) {
        case 'required': text = `Il campo ${error.control_name} è obbligatorio!`; break;
        case 'email': text = `Il campo ${error.control_name} non è nel formato corretto!`; break;
        case 'minlength': text = `Il campo ${error.control_name} ha una lunghezza errata! Deve avere minimo ${error.error_value.requiredLength} caratteri`; break;
        case 'maxlength': text = `Il campo ${error.control_name} ha una lunghezza errata! Deve avere massimo ${error.error_value.requiredLength} caratteri`; break;
        default: text = `${error.control_name}: ${error.error_name}: ${error.error_value}`;
      }
    }
    return text;
  }
}